import { Datatype } from '../../../datatype/Datatype';
import { createConditionOperator } from '../IConditionOperator';

export const ConditionOperatorGreaterType = createConditionOperator({
  code: 'greaterThan',
  label: '>',
  description: 'Maggiore di',
  args: [{ type: 'referenceValue' }],
  allowsField: field =>
    field.type === Datatype.Number || field.type === Datatype.Date,
  compare(value: any, [amount]: [any]) {
    if (amount == null) return false;
    return value > amount;
  },
});
